import React from "react";
import { useSelector } from "react-redux";
import { getDeviceInfo } from "modules/deviceInfo";
import useUserProblemReporter from "./hooks/useUserProblemReporter";

const UserProblemSubscriber = () => {
  const { subscribe, unsubscribe, reportProblem } = useUserProblemReporter();
  const { audioInputDevices, videoInputDevices } = useSelector(getDeviceInfo);

  const checkDevices = async () => {
    let data = null;

    if (!videoInputDevices.length) {
      data = { noCam: true };
    }

    if (!audioInputDevices.length) {
      data = { ...data, noMic: true };
    }

    if (data) {
      reportProblem(data);
    }
  };

  React.useEffect(() => {
    subscribe();
    checkDevices();

    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default UserProblemSubscriber;
